const htmlTitle = (title, required) => {
  let html = title || '(Empty title)';
  if (required) {
    html += ' *';
  }
  return { __html: html };
};

export default htmlTitle;
